module KendoWidgets
{
	export class TreeViewOptions implements kendo.ui.TreeViewOptions
	{

	}

	export class TreeView extends kendo.ui.TreeView implements KendoWidget
	{
		public controlType(): ControlTypeEnum { return ControlTypeEnum.TreeView; }

		constructor(element: Element, options?: KendoWidgets.TreeViewOptions)
		{
			if (options == null)
				options = new KendoWidgets.TreeViewOptions();


			super(element, options);
		}
	}

	TreeView.fn = TreeView.prototype;
	TreeView.fn.options = $.extend(true, {}, kendo.ui.TreeView.fn.options);
	TreeView.fn.options.name = "TreeView";
	kendo.ui.plugin(TreeView);
}

interface JQuery
{
	kendoTreeView(options?: KendoWidgets.TreeViewOptions): JQuery;
}